import { render, staticRenderFns } from "./UIMentionCard.vue?vue&type=template&id=3b70d78d"
import script from "./UIMentionCard.vue?vue&type=script&lang=js"
export * from "./UIMentionCard.vue?vue&type=script&lang=js"
import style0 from "./UIMentionCard.vue?vue&type=style&index=0&id=3b70d78d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Truncate: require('/skade-pwa/components/ui/atom/Truncate.vue').default,Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
